import { render, staticRenderFns } from "./PublicRegionContactContainer.vue?vue&type=template&id=d2d1feaa"
import script from "./PublicRegionContactContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicRegionContactContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports